export default __webpack_public_path__ + "static/media/CTScan.3fe42d56.png";